import { render, staticRenderFns } from "./PlGuide.vue?vue&type=template&id=22150cf2&scoped=true"
import script from "./PlGuide.vue?vue&type=script&lang=js"
export * from "./PlGuide.vue?vue&type=script&lang=js"
import style0 from "./PlGuide.vue?vue&type=style&index=0&id=22150cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22150cf2",
  null
  
)

export default component.exports